export default [

     {
          path: '/appetite-tolerance',
          name: 'appetiteTolerance',
          component: () => import("@/views/Page/appetiteTolerance/appetiteTolerance.vue"),
           meta: {
               title: 'appetiteTolerance',
          },
     }
];